import React from "react"
import logo from "../../assets/images/Wwings.png"

// Suspense fallback for lazy-loaded route chunks — shown briefly while
// navigating to a page whose code hasn't been fetched yet. Previously a
// generic reactstrap spinner; this reuses the same soar + glow motion as the
// app's other loading states (see OcrLoader.jsx and public/index.html) so the
// brand shows the same "thinking" animation everywhere instead of a
// different one per screen.
const styles = `
@keyframes wwspin-soar {
  from { transform: translateY(3px) rotate(-1deg); }
  to   { transform: translateY(-6px) rotate(1deg); }
}
@keyframes wwspin-glow {
  0%, 100% { opacity: .5; transform: scale(.92); }
  50%      { opacity: .8; transform: scale(1.04); }
}

.wwspin-wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.wwspin-glow {
  position: absolute;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(27,20,100,.16) 0%, rgba(27,20,100,0) 70%);
  animation: wwspin-glow 2.4s ease-in-out infinite;
}

.wwspin-logo {
  position: relative;
  width: 48px;
  height: 48px;
  object-fit: contain;
  animation: wwspin-soar 1.8s ease-in-out infinite alternate;
}

@media (prefers-reduced-motion: reduce) {
  .wwspin-logo,
  .wwspin-glow {
    animation: none;
  }
}
`

const Spinners = () => (
  <React.Fragment>
    <style>{styles}</style>
    <div className="wwspin-wrap" role="status" aria-label="Loading">
      <span className="wwspin-glow" />
      <img src={logo} alt="" className="wwspin-logo" draggable={false} />
    </div>
  </React.Fragment>
)

export default Spinners
